export const GOOGLE_MAPS_DEFAULT_ZOOM = 14;
export const GOOGLE_MAPS_ZOOM_MIN = 1;
export const GOOGLE_MAPS_ZOOM_MAX = 21;
